module.exports = __webpack_public_path__ + "static/media/img-02.8b6833c7.jpg";